import { type FunctionComponent } from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { HeaderTab } from "scmp-app/components/tracking/google-analytics-4/types";

import { Container, EpaperLinkList } from "./styles";

type Props = {
  className?: string;
};

export const EpaperLink: FunctionComponent<Props> = ({ className }) => {
  const { rosettaInstance } = useSdkContext();
  const hasEpaperAccessRight = !!rosettaInstance?.rulesEngine.getOutcome(
    "user.hasEpaperAccessRight",
  );

  const getTabClickHandler = (headerTab: HeaderTab) => () => {
    sendGA4Tracking({
      action: "click",
      category: "header",
      customized_parameters: {
        header: headerTab,
      },
      subcategory: "",
    });
  };

  if (!hasEpaperAccessRight) {
    return null;
  }

  return (
    <Container className={className}>
      <EpaperLinkList
        isAnchor
        onClick={getTabClickHandler("epaper")}
        pathname="https://scmp_epaper.pressreader.com/"
        target="_blank"
      >
        ePAPER
      </EpaperLinkList>
    </Container>
  );
};

EpaperLink.displayName = "EpaperLink";
